<script setup>
import { ref, computed } from "vue";
import CommonModal from "common/vue/components/CommonModal.vue";
import { useDtfStore } from "./store";
import ArtworkImage from "./ArtworkImage.vue";
import UseSvg from "../vue-cart/UseSvg.vue";

defineProps({
  artwork: {
    type: Object,
    required: true
  },
  activeConfigSection: {
    type: String,
    required: true
  }
});

const store = useDtfStore();
const isStandardArtwork = computed(() => store.isStandardArtwork);
const showComparisonModal = ref(false);

function toggleComparisonModal() {
  showComparisonModal.value = !showComparisonModal.value;
}
</script>

<template>
  <button
    v-if="isStandardArtwork && !artwork.isLoading && artwork.url"
    class="artwork-full-screen__button"
    type="button"
    @click="toggleComparisonModal"
  >
    <UseSvg class="artwork-full-screen__button-icon" icon="full-screen" />
    <span>Full Screen</span>
  </button>
  <CommonModal v-if="isStandardArtwork && showComparisonModal" @on-close="toggleComparisonModal">
    <div class="artwork-full-screen__artwork-image">
      <ArtworkImage
        :key="artwork.id"
        :artwork="artwork"
        fit-to-container
        :active-config-section="activeConfigSection"
      />
    </div>
  </CommonModal>
</template>

<style lang="scss" scoped>
@import "frontend/init/jiffy/settings.scss";
@import "frontend/init/jiffy/mixin.scss";

.artwork-full-screen {
  &__button {
    display: flex;
    align-items: center;
    justify-content: center;
    border: none;
    padding: 8px;
    gap: 8px;
    border-radius: 0px 0px 8px 8px;
    background: $crafterpay-gray-modern-100;
    color: $scorpion;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    top: -18px;
    position: relative;
    margin: 0px 15px;
    width: calc(100% - 20px);
  }

  &__button-icon {
    width: 24px;
    height: 24px;
  }

  &__artwork-image {
    padding-top: 35px;
    padding-left: 10px;

    @include with-desktop {
      padding-left: 0;
    }
  }
}
</style>
